import apiClient from "../config/api";

/** Must match NavigationAccessContext NAV_SCOPE_STORAGE_KEY */
const NAV_SCOPE_SESSION_KEY = "pm_nav_scope_v2";

let _navScopeCache = null;

export function clearNavScopeMemoryCache() {
  _navScopeCache = null;
}

const dashboardService = {
  /** Home "Your workspace" Overview tiles — ordered nav keys from tenant config (null = default). */
  getWorkspaceOverview: async () => {
    const response = await apiClient.get("/dashboard/workspace-overview");
    return response.data;
  },

  /** When scopeActive, only allowedNavKeys (+ exempt Settings/shell) apply; RBAC still applies. */
  getNavAppScope: async (forceRefresh = false) => {
    if (_navScopeCache && !forceRefresh) {
      return _navScopeCache;
    }
    const response = await apiClient.get("/dashboard/nav-app-scope");
    _navScopeCache = response.data;
    return _navScopeCache;
  },

  clearNavScopeMemoryCache,

  /**
   * After login: fetch nav-app scope once, seed memory cache + sessionStorage so NavigationAccessProvider
   * hydrates with loading=false and Apps menu does not wait on a second round-trip to /home.
   */
  primeNavAppScopeForNewSession: async () => {
    clearNavScopeMemoryCache();
    const response = await apiClient.get("/dashboard/nav-app-scope");
    _navScopeCache = response.data;
    const data = response.data;
    if (typeof window !== "undefined") {
      const tid = parseInt(localStorage.getItem("tenantId") || "0", 10);
      sessionStorage.setItem(
        NAV_SCOPE_SESSION_KEY,
        JSON.stringify({
          tenantId: tid,
          scopeActive: !!data?.scopeActive,
          allowedNavKeys: data?.allowedNavKeys,
          appCodes: data?.appCodes,
        }),
      );
    }
    return data;
  },
};

export default dashboardService;
